import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_SCHEDULE_SITE_WORK_DATES: createSagaAction('GET_SCHEDULE_SITE_WORK_DATES'),
  ADD_SCHEDULE_SITE_WORK_DATE: createSagaAction('ADD_SCHEDULE_SITE_WORK_DATE'),
  DELETE_SCHEDULE_SITE_WORK: createSagaAction('DELETE_SCHEDULE_SITE_WORK'),
  SCHEDULE_SITE_WORK_UPDATE: createSagaAction('SCHEDULE_SITE_WORK_UPDATE'),
  SCHEDULE_SITE_WORK_UPDATE_NOTE: createSagaAction('SCHEDULE_SITE_WORK_UPDATE_NOTE')
}

// Action Creators
export const actions = {
  getScheduleSiteWorkDates: ({ jobId }) => ({
    type: constants.GET_SCHEDULE_SITE_WORK_DATES.ACTION,
    jobId
  }),

  addScheduleSiteWorkDate: ({ jobId, userId, scheduleId }) => ({
    type: constants.ADD_SCHEDULE_SITE_WORK_DATE.ACTION,
    jobId,
    userId,
    scheduleId
  }),

  deleteScheduleSiteWork: ({ jobId, scheduleId }) => ({
    type: constants.DELETE_SCHEDULE_SITE_WORK.ACTION,
    jobId,
    scheduleId
  }),

  updateSiteWorkDates: ({ jobId, userId, scheduleId, scheduleType, description, content }) => ({
    type: constants.SCHEDULE_SITE_WORK_UPDATE.ACTION,
    jobId,
    scheduleId,
    userId,
    scheduleType,
    description,
    content
  }),

  updateNotes: ({ jobId, userId, notes }) => ({
    type: constants.SCHEDULE_SITE_WORK_UPDATE_NOTE.ACTION,
    jobId,
    userId,
    notes
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_SCHEDULE_SITE_WORK_DATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SCHEDULE_SITE_WORK_DATES.SUCCESS:
      return {
        ...state,
        scheduleSiteWorkDates: action.payload
      }
    case constants.DELETE_SCHEDULE_SITE_WORK.SUCCESS:
      return {
        ...state
      }
    case constants.ADD_SCHEDULE_SITE_WORK_DATE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_SCHEDULE_SITE_WORK_DATES.FAILED:
      return {
        error: action.message
      }
    case constants.SCHEDULE_SITE_WORK_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.SCHEDULE_SITE_WORK_UPDATE_NOTE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/scheduleSiteWorkActions.js